import React from "react";
import reactDOM from "react-dom";
import App from "./app";
import "./assets/styles/default.css";

reactDOM.render(<App />, window.document.getElementById("root"));
